export const SET_REWARDS = 'SET_REWARDS'
export const SELECT_COURSES = 'SELECT_COURSES'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'
export const SET_REWARD_NAME = 'SET_REWARD_NAME'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_REWARDS_BY_ID = 'SET_REWARDS_BY_ID'
export const SET_REWARDS_LOADED = 'SET_REWARDS_LOADED'
export const SET_CURRENT_REWARD = 'SET_CURRENT_REWARD'
export const TOGGLE_EDIT_OVERLAY = 'TOGGLE_EDIT_OVERLAY'
export const SET_CURENT_REWARD_NAME = 'SET_CURENT_REWARD_NAME'
export const SET_COURSES_WITH_POINTS = 'SET_COURSES_WITH_POINTS'
export const SET_SEARCH_VALUE_ON_CLICK = 'SET_SEARCH_VALUE_ON_CLICK'